module.exports = __webpack_public_path__ + "img/step.f7139c62.jpg";